import type { ECategoryItem, ECategoryMap, GeneralID } from '@types';

export function removeSceneIdList(
  idList: GeneralID[],
  categoryItem?: ECategoryItem
): void {
  if (!categoryItem) return;
  categoryItem.sceneIds = categoryItem.sceneIds.filter(
    (_id) => !idList.includes(_id)
  );
}

export function removeCategoryId(
  categoryId: GeneralID,
  categoryItem?: ECategoryItem
): void {
  if (!categoryItem) return;
  const index = categoryItem.categoryIds.findIndex((_id) => _id === categoryId);
  categoryItem.categoryIds.splice(index, 1);
}

export function getAllSceneIds(
  map: ECategoryMap,
  categoryId: number
): GeneralID[] {
  let ids: GeneralID[] = [];
  function getIds(id: number) {
    const { categoryIds, sceneIds } = map.get(id)!;
    if (categoryIds.length) {
      for (let i = 0; i < categoryIds.length; i++) {
        getIds(categoryIds[i]);
      }
    } else {
      ids = [...ids, ...sceneIds];
    }
  }
  getIds(categoryId);
  return ids;
}

export function getAllCategoryIds(
  map: ECategoryMap,
  categoryId: number
): number[] {
  let ids: number[] = [];
  function getIds(id: number) {
    const { categoryIds } = map.get(id)!;
    if (categoryIds.length) {
      ids = [...ids, ...categoryIds];
      for (let i = 0; i < categoryIds.length; i++) {
        getIds(categoryIds[i]);
      }
    }
  }
  getIds(categoryId);
  return ids;
}
